import React from 'react';
import texts from '@molecules/DownloadAppQrCode/en.json';
import { Image, Modal, Text } from '@ui/atoms';
import {
    idleFunction,
    replaceKeysWithValues,
} from '@helpers/miscelleanous';
import { appQrCode, brandName } from '@helpers/constants';
import Button from '@ui/atoms/design-system/Button';

const DownloadAppQrCode = ({ show = false, onClose = idleFunction }) => {
    return (
        <Modal
            show={show}
            onClose={onClose}
            roundedClass={'rounded-2xl'}
            width="hidden md:block md:w-[453px]"
            className="!p-0"
            hideTitle={true}
            children={
                <>
                    <div className="relative px-16 pt-10 pb-8 flex flex-col gap-6 items-center">
                        <div className="flex flex-col gap-4 items-center">
                            <div className="flex flex-col gap-3 items-center">
                                <Text
                                    content={
                                        texts?.YourInvestmentJourneySimplified
                                    }
                                    className="p2-regular text-primary-500"
                                />
                                <div className="flex gap-3 items-center">
                                    <Image
                                        src={'/images/app-qr-stroke.svg'}
                                        alt="qr-code-stroke"
                                        className="w-[23px]"
                                    />
                                    <Text
                                        content={replaceKeysWithValues(
                                            texts?.DownloadBrandApp,
                                            {
                                                '{brand}': brandName,
                                            }
                                        )}
                                        className="p1-semibold text-primary-500"
                                    />
                                    <Image
                                        src={'/images/app-qr-stroke.svg'}
                                        alt="qr-code-stroke"
                                        className="w-[23px] rotate-180"
                                    />
                                </div>
                            </div>
                            <Text
                                content={texts?.ScanQrCodeToDownload}
                                className="p4-regular text-gray-500"
                            />
                            <div className="rounded-2xl border border-primary-100">
                                <Image
                                    src={appQrCode}
                                    alt="qr-code"
                                    className="w-[200px] h-[200px] rounded-2xl"
                                />
                            </div>
                        </div>
                        <Button
                            onClick={onClose}
                            id="closeQrCode"
                            buttonSize="extraSmall"
                            buttonType="textUnderline"
                            buttonText={texts?.Close}
                        />
                    </div>
                </>
            }
        />
    );
};

export default DownloadAppQrCode;
